import { Buffer } from "buffer";

const globalWithBuffer = globalThis as typeof globalThis & { Buffer?: typeof Buffer };
if (typeof globalWithBuffer.Buffer === "undefined") {
  globalWithBuffer.Buffer = Buffer;
}

// Shim for bitcore-lib and similar libraries that expect a Node.js-style assert.
if (typeof window !== "undefined" && !("assert" in window)) {
  // @ts-expect-error assert is not part of the Window interface
  window.assert = (condition: unknown, message?: string) => {
    if (!condition) {
      throw new Error(message || "Assertion failed");
    }
  };
}
